import { Inject, Injectable, OnInit } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public onLogin: Subject<any> = new Subject<any>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService
  ) {}

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  logout() {
    this.msalService.logout();
  }

  isLoggedIn() {
    return !!this.msalService.instance.getActiveAccount();
  }

  userName() {
    return this.msalService.instance.getActiveAccount().username;
  }

  allowedDebugUsers() {
    return [
      "akhalid@shawarmer.com",
      "jalshamiri@shawarmer.com",
      "mkhairi@shawarmer.com",
    ];
  }

  name() {
    return this.msalService.instance.getActiveAccount()?.name;
  }

  roles(): string[] {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (this.msalService.instance.getActiveAccount().idTokenClaims as any)
        .roles;
    }

    return [];
  }

  isAdmin(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("Admin");
    }

    return false;
  }

  isCallCenterAgent(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("Agent");
    }

    return false;
  }

  isMenuMaker(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("MenuMaker");
    }

    return false;
  }

  isStoreActivationManager(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("StoreActivationManager");
    }

    return false;
  }

  isDonationManager(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("DonationManager");
    }

    return false;
  }

  isCateringManager(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("CateringManager");
    }

    return false;
  }

  isOnlineOperationAgent(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("OnlineOperationAgent");
    }

    return false;
  }

  isCorpManager(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("CorpManager");
    }

    return false;
  }

  isFranchiseManager(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("FranchiseManager");
    }

    return false;
  }

  isITSupport(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("ITSupport");
    }

    return false;
  }

  isItemShowHideOperations(): boolean {
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return (
        this.msalService.instance.getActiveAccount().idTokenClaims as any
      ).roles.includes("ItemShowHideOperations");
    }

    return false;
  }

  fetchToken() {
    for (var prop in localStorage) {
      if (prop.includes("login.windows.net-idtoken")) {
        let idToken = JSON.parse(localStorage[prop]);
        localStorage.setItem("token", idToken.secret);
      }
    }
  }

  getToken(): string {
    return localStorage.getItem("token");
  }

  softLogout() {
    localStorage.clear();
  }
}